interface Props {
  children: any;
  prueba?: string;
}

const BtnGroup = ({ children, prueba }: Props) => {
  return (
    <div className="btn-group" role="group" aria-label="Opciones">
      {children}
    </div>
  );
};

export { BtnGroup };
